import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { GET_Field_VOCABULARY_RECORDS } from "../actions";
import centralApiAxios from "../../axios/centralApiAxios";

import {
  getVocabularyRecordsSuccess,
  getVocabularyRecordsError,
} from "./actions";

export function* watchGetVocabularyListRecords() {
  yield takeEvery(GET_Field_VOCABULARY_RECORDS, getVocabularyList);
}

const getCurrentPageRecords = (allRecords, pageNumber, pageSize) => {
  let currentPageRecords = [];
  if (Object.keys(allRecords).length > 0) {
    for (var key in allRecords) {
      currentPageRecords.push({
        ...allRecords[key],
        id: key,
      });
    }
  }
  let startIndex = (pageNumber - 1) * pageSize;
  let lastIndex = startIndex + pageSize;
  currentPageRecords = currentPageRecords.slice(
    startIndex,
    currentPageRecords.length >= lastIndex
      ? lastIndex
      : currentPageRecords.length
  );
  return currentPageRecords;
};
 // eslint-disable-next-line 
const getVocabularyListAsync = async (payload) => {
    try {

    const responseObject = await centralApiAxios.get("/vocabularies?trashed=false&page_size=-1");
        
    return {
          recordTermList: responseObject.data.items,
          message: null,
        };   

    } catch (error) {
        return {
            message: 'Failed to get vocabulary. ' + error
        }
    }
}

function* getVocabularyList({ payload }) {
  try {
    const recordListReturned = yield call(getVocabularyListAsync, payload);
    if (!recordListReturned.message) {
      let recordListParam = {
        records: getCurrentPageRecords(
          recordListReturned.recordTermList,
          payload.pageNumber,
          5
        ),
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize: 5,
          startIndex: (payload.pageNumber - 1) * 5 + 1,
          totalItemCount: Object.keys(recordListReturned.recordTermList).length,
          totalPages: Math.ceil(
            Object.keys(recordListReturned.recordTermList).length / 5
          ),
        },
        responseTime: recordListReturned.responseTime,
      };
      yield put(getVocabularyRecordsSuccess(recordListParam));
    } else {
      yield put(getVocabularyRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getVocabularyRecordsError(error));
  }
}

export default function* rootSaga() {
  yield all([fork(watchGetVocabularyListRecords)]);
}